import Component from "./Filters";
export default Component;
